import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

export const drawerItemTextSx = {
  color: "custom.ink",
  "& .MuiListItemText-primary": {
    fontFamily: FONT_UI,
    fontSize: "0.9375rem",
    fontWeight: 600,
  },
};

export const drawerChildTextSx = {
  color: "custom.inkMuted",
  "& .MuiListItemText-primary": {
    fontFamily: FONT_UI,
    fontSize: "0.8125rem",
    fontWeight: 400,
  },
};
